/**
 * The four supported report cadences, expressed as the `reportRange` hour values
 * the API expects. The wire format stays hours; the UI only offers these four.
 */
export const REPORT_SCHEDULE_OPTIONS = [
    { value: 24, label: 'Daily' },
    { value: 84, label: 'Twice per week' },
    { value: 168, label: 'Weekly' },
    { value: 336, label: 'Once in two weeks' },
];

/** Weekly — matches the cadence the backend applies to new tasks. */
export const DEFAULT_REPORT_RANGE_HOURS = 168;

/** Snap an arbitrary stored reportRange to the closest supported option. */
export function normalizeReportRange(hours) {
    const h = Number(hours);
    if (!Number.isFinite(h) || h <= 0) return DEFAULT_REPORT_RANGE_HOURS;
    return REPORT_SCHEDULE_OPTIONS.reduce((best, o) =>
        Math.abs(o.value - h) < Math.abs(best.value - h) ? o : best,
    ).value;
}

/** True when the value is exactly one of the offered cadences. */
export function isReportScheduleValue(hours) {
    return REPORT_SCHEDULE_OPTIONS.some((o) => o.value === Number(hours));
}

/** Display label; falls back to raw hours for legacy off-grid values. */
export function reportScheduleLabel(hours) {
    const h = Number(hours);
    if (!Number.isFinite(h) || h <= 0) return '—';
    const match = REPORT_SCHEDULE_OPTIONS.find((o) => o.value === h);
    return match ? match.label : `${h} hours`;
}
